export default {"src":"/_next/static/media/aced_badge.83568741.svg","height":432,"width":432,"blurWidth":0,"blurHeight":0};